import React from 'react';
import { pickDataAttributes } from '@gafe/common-ui';
import { sumBy } from 'lodash';

import { getOrderItemName, getOrderItemPrice } from '@/components/modals/SubmitOrder/constants';
import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';
import { OrderItemWrapper } from '@/components/modals/SubmitOrder/types';
import { formatPriceWithCurrency } from '@/utils/format-price';

import { OrderDetails } from '../../../Common/OrderDetails';
import {
  bundleItemsBySystemGroup,
  getBundleTotal,
  systemGroup,
} from '../../../OrderDetailsStep/components/ServiceDetails/constants';

import { Props } from './types';

import styles from '../../ConfirmationStep.module.scss';

export const ConfirmationContentDetails = ({
  itemsToRender: orderItems,
  itemsTotal,
  proposal,
  title,
  ...props
}: Props) => {
  const state = useOrderContext();
  const { modifiedArray: itemsWithoutBasicServices, bundleServices: basicServicesBundle } =
    bundleItemsBySystemGroup(orderItems, systemGroup['TS Basic Services']);
  const hasBasicServicesBundleItems = basicServicesBundle.length > 1;
  const basicServicesTotal = getBundleTotal(basicServicesBundle, state, proposal);
  const itemsToRender = hasBasicServicesBundleItems ? itemsWithoutBasicServices : orderItems;
  const bundledOrderItemsTotal = hasBasicServicesBundleItems
    ? sumBy(itemsWithoutBasicServices, service => getOrderItemPrice(state, service, proposal)) +
      basicServicesTotal
    : itemsTotal;

  const renderBasicServicesBundle = hasBasicServicesBundleItems ? (
    <div className={styles.order_list_body_item}>
      <div className={styles.order_list_body_raw}>
        <span className={styles.order_list_body_item_bold}>Timberline Solar Basic Services</span>
        {!state.isPriceHidden && (
          <span className={styles.order_list_body_item_bold}>
            {formatPriceWithCurrency(basicServicesTotal)}
          </span>
        )}
      </div>
    </div>
  ) : null;

  return (
    <OrderDetails
      hideValue={state.isPriceHidden}
      title={title}
      value={bundledOrderItemsTotal}
      {...pickDataAttributes(props)}
    >
      {itemsToRender.length > 0 &&
        itemsToRender.map((e: OrderItemWrapper) => (
          <div className={styles.order_list_body_item} key={e.orderItem.productId}>
            <div className={styles.order_list_body_raw}>
              <span className={styles.order_list_body_item_bold}>{getOrderItemName(e)}</span>
              {!state.isPriceHidden && (
                <span className={styles.order_list_body_item_bold}>
                  {formatPriceWithCurrency(getOrderItemPrice(state, e, proposal))}
                </span>
              )}
            </div>
          </div>
        ))}
      {renderBasicServicesBundle}
    </OrderDetails>
  );
};
